import { createPortal } from 'react-dom';

import './index.scss'

type LoaderProps = {
  isVisible: boolean;
}

var arr = Array(6).fill(0);
var renderEllipsis = arr.map((item, i) => <div key={i}></div>);

const LoaderPortal = (<div>
  <div data-testid='loader-overlay' className="lds-overlay-fixed lds-ellipsis">
    {renderEllipsis}
  </div>
  <div className="lds-overlay-fixed lds-overlay"></div>
</div>);

export const Loader = ({ isVisible }: LoaderProps) => isVisible ? createPortal(LoaderPortal, document.body) : null;
